import { HTTP } from "@/utils/http-common"

export default {
  mergeDuplicates($, pairs, dryRun = false) {
    return new Promise((resolve, reject) => {
      HTTP.post("/perfumist/back-office/admin/products/merge-duplicates/", {
        pairs,
        dry_run: dryRun
      })
        .then(r => resolve(r.data))
        .catch(err => {
          const msg = err.response?.data?.error || "Merge failed"
          $.$store.commit("error", { msg, color: "error" })
          reject(err)
        })
    })
  }
}
